module.exports = __webpack_public_path__ + "img/c2.fc81df62.jpg";